// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1___40891d182b11d3f8ec5","cls2":"CreateSocialItem-cls2___e6329e63cbf539d5fc8 CreateSocialItem-cls1___40891d182b11d3f8ec5"};